export const NOTE_WIDGET_EDIT = 'NOTE_WIDGET_EDIT';
export const IFRAME_WIDGET_EDIT = 'IFRAME_WIDGET_EDIT';
export const DELETE_NON_REPORT_WIDGET = 'DELETE_NON_REPORT_WIDGET';